import { useMutation } from '@tanstack/react-query';

import { post } from '@eika-infrastruktur/request';

import { KREDITTBANKEN_BASE_URL } from '@/react-query/common';

import { PendingCardTokenKb } from '../types';

const activateToken = async (item: PendingCardTokenKb) =>
    post<void>(
        `${KREDITTBANKEN_BASE_URL}/wallets/eligible-credit-cards/${item.card.id}/tokens/${item.token.id}/references/${item.token.uniqueReferenceId}`,
    );

export const useActivatePendingCreditCard = () => {
    return useMutation({
        mutationKey: ['activate-pending-card'],
        mutationFn: activateToken,
    });
};
